module.exports = require("i18next-browser-languagedetector");